<template>
    <div>
    <b-card class="card-news-form" header-tag="header" footer-tag="footer">
      <!-- for loading page -->
      <app-loading :className="isLoading ? 'loading' : ''"></app-loading>

        <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
            News Form
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">docs</small>
            </a>
          </div>
        </div>
        <div>

          <b-row>
            <b-col sm="12">
              <alert-success :redirectName="'news-home'" :show="successMessage != ''"> {{ successMessage }} </alert-success>
              <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
              <!-- Thumbnail -->
              <b-form-group>
                <div class="text-center">
                  <img class="thumbnail" :src="previewThumbnail" alt="Thumbnail">
                </div>
                <b-input-group>
                <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="thumbnailFile">
                    <label class="custom-file-label"> {{ thumbnail.name || 'choose thumbnail file' }} </label>
                </div>
                <b-button variant="outline-secondary" @click="previewThumbnail = '/images/101/thumbnail.png'; thumbnail = {}">
                  Set Default
                </b-button>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>

              <!-- type -->
              <b-form-group>
                <label for="sendTo">Type</label>
                <b-input-group>
                <b-form-select v-model="form.type" :options="typeOptions"></b-form-select>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>

              <!-- Show -->
              <b-form-group>
                <label for="sendTo">Setting</label>
                <b-input-group>
                 <b-form-checkbox
                  v-model="form.hero"
                >
                  Show content in main page.
                </b-form-checkbox>
                </b-input-group>
              </b-form-group>

              <!-- Title -->
              <b-form-group>
                <label for="sendTo">Title</label>
                <b-input-group prepend="TH">
                    <b-input :state="feedback(fieldErrors.titleTH)" v-model="form.titleTH" placeholder="กรุณาใส่หัวข้อภาษาไทย"></b-input>
                </b-input-group>
                <b-input-group prepend="EN">
                    <b-input :state="feedback(fieldErrors.titleEN)" v-model="form.titleEN" placeholder="please enter english title."></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Description -->
              <b-form-group>
                <label for="sendTo">Description TH</label>
                <ckeditor
                    :editor="editor"
                    v-model="form.descriptionTH"
                    :config="editorConfig"
                ></ckeditor>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
              </b-form-group>

              <!-- descriptionEn -->
                <b-form-group>
                <label for="sendTo">Description EN</label>
                <ckeditor
                    :editor="editor"
                    v-model="form.descriptionEN"
                    :config="editorConfig"
                ></ckeditor>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
              </b-form-group>

              <!-- location -->
              <b-form-group>
                <label for="sendTo">Location</label>
                <b-input-group prepend="TH">
                    <b-input v-model="form.locationTH" placeholder="กรุณาใส่สถานที่ภาษาไทย"></b-input>
                </b-input-group>
                <b-input-group prepend="EN">
                    <b-input v-model="form.locationEN" placeholder="please enter english location."></b-input>
                </b-input-group>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
              </b-form-group>

              <!-- startDate - finishDate -->
              <b-form-group>
                <label for="sendTo">Start - Finish Event Date</label>
                <v-date-picker
                    mode='range'
                    locale="th-TH"
                    color="gray"
                    :columns="$screens({ default: 1, lg: 2 })"
                    :min-date='new Date()'
                    :popover="{ visibility: 'click' }"
                    :input-props="{ placeholder: 'Please enter date start and finish', readonly: true }"
                    v-model='form.dateRange'
                    >
                </v-date-picker>
              </b-form-group>

              <!-- startTime - finishTime -->
              <b-form-group>
                <label for="sendTo">Start - Finish Event Time</label>
                <b-row class="ml-1">
                    <autocomplete-vue
                    :list="time"
                    placeholder="start"
                    inputClass="form-control"
                    v-model="form.startTime"
                ></autocomplete-vue>
                <div class="fix-font"> To </div>
                <autocomplete-vue
                    :list="time"
                    placeholder="finish"
                    inputClass="form-control"
                    v-model="form.finishTime"
                ></autocomplete-vue>
                </b-row>
                </b-form-group>

                <!-- Start - end showing-->
              <b-form-group>
                <label>Start - End Showing news period</label>
                <b-input-group>
                    <date-time-picker v-model="form.startShowing" :config="datePickerOptions"></date-time-picker>
                    <div class="fix-font"> To </div>
                    <date-time-picker v-model="form.endShowing" :config="datePickerOptions"></date-time-picker>
                </b-input-group>
              </b-form-group>

              <!-- Gallery -->
              <b-form-group>
                <b-button variant="ghost-primary" size="sm" @click="showGallery = !showGallery">
                    Galleries {{ showGallery ? 'hide' : 'show'}}
                    <i class="fa fa-folder-open-o" aria-hidden="true"></i>
                </b-button>
                <font class="hint">* Show as sliding banner at the top of application.</font>
                <app-gallery
                  :show="showGallery"
                  :gallery="form.gallery"
                  :removeGallery="removeGallery">
                </app-gallery>
              </b-form-group>

            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            Back
          </b-button>
          <b-button :disabled="!isActive" @click="saveNews" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
          <b-button :disabled="!isActive" v-b-modal.confirmDelete v-if="$route.params.id" type="reset" size="sm" variant="danger">
            <i class="fa fa-ban"></i>
            Delete
          </b-button>
          <alert-confirm
            :id="'confirmDelete'"
            @confirm="deleteNews">
            confirm to delete ?
          </alert-confirm>
        </div>
    </b-card>
    </div>
</template>
<script>
import AlertSuccess from '../../components/alert/AlertSuccess';
import AlertConfirm from '../../components/alert/AlertConfirm';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic/build/ckeditor';
import CKEditor from '@ckeditor/ckeditor5-vue';
import AutocompleteVue from 'autocomplete-vue';
import { timeAutoComplete, stringFullToDate } from '../../../src/assets/utils/time';
import Loading from '../../components/Loading';
import Gallery from '../../components/Gallery';
import DatePicker from 'vue-bootstrap-datetimepicker';

export default {
  data () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ['bold', 'italic', '|', 'link', 'bulletedList']
      },
      datePickerOptions: {
        format: 'DD/MM/YYYY HH:mm:ss',
        useCurrent: false,
        showClear: true,
        showClose: true,
        locale: 'th'
      },
      errorMessage: '',
      successMessage: '',
      fieldErrors: {},
      alertConfirm: false,
      isActive: true,
      isLoading: false,
      thumbnail: {},
      previewThumbnail: '/images/101/thumbnail.png',
      form: {
        type: 'news',
        titleTH: '',
        titleEN: '',
        descriptionTH: '',
        descriptionEN: '',
        locationTH: '',
        locationEN: '',
        dateRange: '',
        startTime: '',
        finishTime: '',
        gallery: [],
        hero: false,
        startShowing: null,
        endShowing: null
      },
      typeOptions: {
        news: 'news',
        event: 'event',
        promotion: 'promotion'
      },
      showGallery: false,
      removeGallery: []
    };
  },
  mounted () {
    this.getFormData();
  },
  methods: {
    thumbnailFile (e) {
      const files = e.target.files || e.dataTransfer.files;
      this.thumbnail = files[0];
      this.previewThumbnail = URL.createObjectURL(this.thumbnail);
    },
    saveNews () {
      this.isActive = false;
      this.fieldErrors = {};
      this.isLoading = true;
      const id = this.$route.params.id;
      const bodyFormData = new FormData();
      bodyFormData.append('thumbnail', this.thumbnail);
      bodyFormData.append('hero', this.form.hero);
      bodyFormData.append('type', this.form.type);
      bodyFormData.append('titleTH', this.form.titleTH);
      bodyFormData.append('titleEN', this.form.titleEN);
      bodyFormData.append('descriptionTH', this.form.descriptionTH);
      bodyFormData.append('descriptionEN', this.form.descriptionEN);
      bodyFormData.append('locationTH', this.form.locationTH);
      bodyFormData.append('locationEN', this.form.locationEN);
      bodyFormData.append('startDate', this.form.dateRange ? this.form.dateRange.start : '');
      bodyFormData.append('finishDate', this.form.dateRange ? this.form.dateRange.end : '');
      bodyFormData.append('startTime', this.form.startTime ? this.form.startTime : '');
      bodyFormData.append('finishTime', this.form.finishTime ? this.form.finishTime : '');
      bodyFormData.append('removeGallery', this.removeGallery);
      bodyFormData.append('startShowing', this.form.startShowing ? stringFullToDate(this.form.startShowing) : null);
      bodyFormData.append('endShowing', this.form.endShowing ? stringFullToDate(this.form.endShowing) : null);
      // Gallery
      for (const image of this.form.gallery) {
        bodyFormData.append('gallery', image.file ? image.file : null);
      }

      if (id) { // update
        bodyFormData.append('isDeleteThumbnail', '/images/101/thumbnail.png' === this.previewThumbnail);
        this.axios.patch(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/news/' + id, bodyFormData)
          .then(response => {
            this.isLoading = false;
            this.successHandler();
          })
          .catch(error => {
            console.log(error.response || error.message);
            this.isActive = true;
            this.isLoading = false;
            this.errorHandler(error);
          });
      } else { // create
        this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/news/', bodyFormData)
          .then(response => {
            this.isLoading = false;
            this.successHandler();
          })
          .catch(error => {
            console.log(error.response || error.message);
            this.isActive = true;
            this.isLoading = false;
            this.errorHandler(error);
          });
      }
    },
    deleteNews () {
      this.isActive = false;
      this.isLoading = true;
      this.axios.delete(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/news/' + this.$route.params.id)
        .then(response => {
          this.successHandler();
        })
        .catch(error => {
          this.errorHandler(error);
        });
    },
    errorHandler (error) {
      this.errorMessage = error.message;
      if (error.response) {
        this.errorMessage = error.response.data.message;
        const data = error.response.data.data;
        this.setFieldErrors(data);
      }
    },
    successHandler () {
      window.scrollTo(0, 100);
      this.successMessage = 'success';
    },
    setFieldErrors (fields) {
      if (fields) {
        for (const field of fields) {
          this.fieldErrors[field.param] = { message: field.msg, isCorrect: false };
        }
      }
    },
    getFormData () {
      const id = this.$route.params.id;
      if (id) {
        this.isActive = false;
        this.isLoading = true;
        this.axios.get(process.env.VUE_APP_URL_MQDC_API + `/news/${id}`, {
          headers: {
            Accept: 'application/json'
          }
        })
          .then(response => {
            this.isActive = true;
            const data = response.data.data;
            if (!data) {
              throw new Error('data not found');
            }
            this.previewThumbnail = data.thumbnail;
            const dateRange = data.startDate && data.finishDate
              ? { start: new Date(data.startDate), end: new Date(data.finishDate) }
              : '';
            const startShowing = data.showingPeriod.start ? data.showingPeriod.start.timestamp : null;
            const endShowing = data.showingPeriod.end ? data.showingPeriod.end.timestamp : null;
            this.form = {
              hero: !!data.heroUpdatedAt,
              type: data.type,
              titleTH: data.titleTH,
              titleEN: data.titleEN,
              descriptionTH: data.descriptionHtmlTH || data.descriptionTH,
              descriptionEN: data.descriptionHtmlEN || data.descriptionEN,
              locationTH: data.locationTH,
              locationEN: data.locationEN,
              dateRange: dateRange,
              startTime: data.startTime,
              finishTime: data.finishTime,
              startShowing: startShowing ? new Date(startShowing * 1000) : null,
              endShowing: endShowing ? new Date(endShowing * 1000) : null,
              gallery: data.galleries.map(image => { return { id: image.id, url: image.url }; })
            };
          })
          .catch(error => {
            this.errorHandler(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        Object.assign(this.$data, this.$options.data());
      }
    },
    toObjectURL (file) {
      if (!file) {
        return null;
      }
      if (file.url) {
        return file.url;
      } else {
        return URL.createObjectURL(file.file);
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.getFormData();
    }
  },
  computed: {
    feedbackMessage () {
      return data => {
        if (data) {
          return data.message;
        } else {
          return '';
        }
      };
    },
    feedback () {
      return data => {
        if (!data) {
          return null;
        } else {
          return data.isCorrect;
        }
      };
    },
    time () {
      return timeAutoComplete();
    },
    unixTime () {
      return new Date().getTime();
    }
  },
  components: {
    AlertSuccess,
    AlertConfirm,
    ckeditor: CKEditor.component,
    AutocompleteVue,
    'app-loading': Loading,
    'app-gallery': Gallery,
    'date-time-picker': DatePicker
  }
};
</script>

<style scoped>
  .hint{
      font-size: 9px;
      color: #f86c6b;
    }
</style>

<style>
    .card-news-form{
      margin-bottom: 100px;
    }
    .show-thumbnail{
        height: 35px;
    }
    .ck-content { min-height:100px; }
    .ck.ck-button {
        color: #5c6873;
    }
    .autocomplete{
        width: 60px;
        text-align: center;
    }
    .autocomplete__entry{
        text-align: center;
    }
    .autocomplete__entry:hover{
        cursor: pointer;
    }
    .fix-font{
        margin-top: 8px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .thumbnail{
      width: auto;
      max-height: 150px;
      -webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      margin-bottom: 5px;
    }
</style>
